import { OnboardingStep } from 'Webapp/shared/app/components/onboarding';

import codeSplitLoad from 'Webapp/shared/utils/code-split-load';
// actions
import {
  showModal,
  dismissSpecificModal,
} from 'Webapp/shared/app/redux/actions/modal-actions';
const CompleteProfileCollaboratorModal = codeSplitLoad(
  'CompleteProfileCollaboratorModal',
);

const modalSignup: OnboardingStep = (nextStep) => (dispatch) => {
  dispatch(
    showModal(CompleteProfileCollaboratorModal, {
      onComplete: () => {
        dispatch(dismissSpecificModal(CompleteProfileCollaboratorModal));
        nextStep();
      },
    }),
  );
};

export default modalSignup;
